import { getScriptLogsApi, mandiRateUpdateApi, sendSatelliteNotificationsApi, sendSatelliteReportApi, sendUserExpenseNotificationsApi } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getScriptLogs = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(getScriptLogsApi, config);

    return response;
};

export const getMandiRate = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(mandiRateUpdateApi, config);

    return response;
};

export const sendUserExpense = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(sendUserExpenseNotificationsApi, {}, config);

    return response;
};

export const sendSatelliteReport = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(sendSatelliteReportApi, {}, config);

    return response;
};

export const sendSatelliteNotifications = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(sendSatelliteNotificationsApi, {}, config);

    return response;
};